import React, { useState } from 'react'
import { createPortal } from 'react-dom'
import Modal from '@components/modal'
import { useLocalStorage } from '@rehooks/local-storage'
import withTranslate from 'redux-polyglot/translate'
import ModalContent from 'components/ModalContent'
import { getTopSpacingMobileModal } from 'domain/mobileModal'
import TOSPagePath from 'static/termsOfService/index.html'
import { Link, Wrapper } from './style'
import { Approval, Props } from './types'
import { getIsApproved } from './utils'

export const QUOTE_TOS_LC_KEY = 'travel-tos-approval'
export const QUOTE_TOS_VERSION = '2023-01-04'

const QuoteTOS: React.FC<Props> = ({
  className,
  p,
  screenSize
}) => {
  const [approval] = useLocalStorage<Approval>(QUOTE_TOS_LC_KEY, {
    isApproved: false,
    version: QUOTE_TOS_VERSION
  })
  const [isPortalOpen, setIsPortalOpen] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  if (getIsApproved(approval)) return null

  const linkText = p.tc('link_text')
  const textArray = p.tc('text').split('${link}')

  const handleModalClosing: VoidFunction = () => {
    setIsModalOpen(false)
  }

  const handlePortalClosing: VoidFunction = () => {
    setIsPortalOpen(false)
  }

  const handlePortalAndModalOpening: VoidFunction = () => {
    setIsModalOpen(true)
    setIsPortalOpen(true)
  }

  return (
    <>
      <Wrapper className={className}>
        {textArray?.[0]}
        <Link onClick={handlePortalAndModalOpening}>{linkText}</Link>
        {textArray?.[1]}
      </Wrapper>

      {isPortalOpen &&
        createPortal(
          <Modal
            isActive={isModalOpen}
            isMobile={!screenSize.large}
            onCloseEnd={handlePortalClosing}
            onOverlayClick={handleModalClosing}
            topOffset={screenSize.large ? 0 : getTopSpacingMobileModal()}
            style={{
              maxWidth: screenSize.large ? '833px' : undefined,
              minHeight: 'auto',
              position: 'fixed'
            }}
          >
            <ModalContent
              onClose={handleModalClosing}
              title={p.tc('modal_title')}
            >
              <iframe
                src={`${TOSPagePath}?isFramed=1`}
                style={{
                  height: screenSize.large ? '80vh' : '100%',
                  maxHeight: screenSize.large ? '524px' : undefined,
                  maxWidth: screenSize.large ? '833px' : undefined,
                  width: '100vw'
                }}
              />
            </ModalContent>
          </Modal>,
          document.getElementById('portal-modal') as Element
        )}
    </>
  )
}

export default withTranslate('product.packages.pricer.tos')(QuoteTOS)
